exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "token{width:100%;height:100%}.footer-token{font-size:12px}.corDisable{background-color:#f7eb98;border:1px solid #ddd;color:#a9a4a4}.containerNovoCodigo{display:flex;flex-direction:row;font-size:12px}.btnNovoCodigo{background-color:#fff;border:none;margin:0 auto;text-decoration:underline;font-weight:700;color:#000}.btnNovoCodigoDisabled{font-weight:500;text-decoration:none;color:grey}.containerOpcaoNovoCodigo{display:flex;flex-direction:column;align-items:center;margin-bottom:10px}.titleOpcaoNovoCodigo{font-size:12px;font-weight:600;text-align:center;margin:0 auto}.btnOpcaoNovoCodigo{margin:8px;width:100%;padding:8px;background-color:#fdcf00;border:1px solid #bfbfbf;border-radius:6px}.linhaBottom{border-bottom:1px solid #ccc}.linhaTop{border-top:1px solid #ccc}.texto-passo{color:#a9a4a4;text-transform:uppercase;text-align:center}.texto-reenvio-codigo{font-size:12px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/components/views/tokenSms/tokenSms.style.scss
// module id = 780
// module chunks = 0